// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.swipe_jxIVV, .swiping_M3be6 {
  height : 100%;
}

.swipe_jxIVV > *, .zeroHeight_aA0_M {
  transition : height 0.3s;
}

.showList_hd1Cn {
  bottom : 0;
  left : 0;
  right : 0;
  background-color : white;
  height : 40px;
  display : flex;
  position : absolute;
}

.background_bcr_D {
  position : relative;
}

.top_PzUOs {
  position : relative
}

.bottom_TVxK4 {
  position : relative
}

.overlay_zNwjq {
  position : absolute;
  left : 0;
  right : 0;
  bottom : 0;
  z-index : 101;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

.overlayContainer_gMJLJ {
  background-color: var( --color-white );
}

.divider_agBIo {
  height: 32px;
  width: 100%;
  display: flex;
  border: 1px solid var( --color-base100 );
  background-color: var( --color-white );
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  box-shadow : 0px 1px 3px rgba(41, 50, 61, 0.16);
  flex-shrink: 0;
}

.dividerTop_FFqJ6 {
  border-radius: 0;
}

.dividerMark_QRTvx {
  margin: auto;
  height: 0;
  width: 32px;
  border: 2px solid var( --color-base300 );
  border-radius: 8px;
}

.zeroHeight_aA0_M {
  height: 0;
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/views/swipe/Swipe.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;EACT,wBAAwB;EACxB,aAAa;EACb,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,wCAAwC;EACxC,sCAAsC;EACtC,4BAA4B;EAC5B,6BAA6B;EAC7B,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,WAAW;EACX,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB","sourcesContent":[".swipe, .swiping {\n  height : 100%;\n}\n\n.swipe > *, .zeroHeight {\n  transition : height 0.3s;\n}\n\n.showList {\n  bottom : 0;\n  left : 0;\n  right : 0;\n  background-color : white;\n  height : 40px;\n  display : flex;\n  position : absolute;\n}\n\n.background {\n  position : relative;\n}\n\n.top {\n  position : relative\n}\n\n.bottom {\n  position : relative\n}\n\n.overlay {\n  position : absolute;\n  left : 0;\n  right : 0;\n  bottom : 0;\n  z-index : 101;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n}\n\n.overlayContainer {\n  background-color: var( --color-white );\n}\n\n.divider {\n  height: 32px;\n  width: 100%;\n  display: flex;\n  border: 1px solid var( --color-base100 );\n  background-color: var( --color-white );\n  border-top-left-radius: 16px;\n  border-top-right-radius: 16px;\n  box-shadow : 0px 1px 3px rgba(41, 50, 61, 0.16);\n  flex-shrink: 0;\n}\n\n.dividerTop {\n  border-radius: 0;\n}\n\n.dividerMark {\n  margin: auto;\n  height: 0;\n  width: 32px;\n  border: 2px solid var( --color-base300 );\n  border-radius: 8px;\n}\n\n.zeroHeight {\n  height: 0;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"swipe": `swipe_jxIVV`,
	"swiping": `swiping_M3be6`,
	"zeroHeight": `zeroHeight_aA0_M`,
	"showList": `showList_hd1Cn`,
	"background": `background_bcr_D`,
	"top": `top_PzUOs`,
	"bottom": `bottom_TVxK4`,
	"overlay": `overlay_zNwjq`,
	"overlayContainer": `overlayContainer_gMJLJ`,
	"divider": `divider_agBIo`,
	"dividerTop": `dividerTop_FFqJ6`,
	"dividerMark": `dividerMark_QRTvx`
};
export default ___CSS_LOADER_EXPORT___;
